import { BackendAppApiV2SchemasStockTakingSchemasStockTakingTaskResponse } from '../../services/api';
import { amsLegacyService } from '../../services';
import { useAsync } from '.';

export interface IStockTakingTasks<T> {
  tasks: T;
  loading: boolean;
}

/**
 *
 * @deprecated
 */
const useStocktakingTasks = (
  id?: number
): IStockTakingTasks<BackendAppApiV2SchemasStockTakingSchemasStockTakingTaskResponse[]> => {
  const { data, loading } = useAsync<
    BackendAppApiV2SchemasStockTakingSchemasStockTakingTaskResponse[]
  >(amsLegacyService.getStocktakingTasks, [], id ? [id] : null);
  return {
    tasks: data,
    loading
  };
};

export default useStocktakingTasks;
